import React, { Dispatch, FC, SetStateAction } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import {
  CreateBranchingDetailsProps,
  FormQuestion,
  FormQuestionType,
  FormTemplate,
} from 'api/form/types';
import { ReactComponent as FormFieldPropertiesEmptyImage } from 'assets/svgs/form-field-properties.svg';
import { Button } from 'components/atoms/button';
import { Caption01 } from 'components/styles';
import { useTranslation } from 'hooks/use-translation';
import { FormHeaderID } from '../constants';
import { FormFieldConfiguration } from './form-field-configuration';
import { FormHeaderConfiguration } from './form-header-configuration';
import { MatrixFormField } from './matrix-form-field-configuration';

const WrapperHeight = 250;

const FieldConfigurationEmpty = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  justify-content: center;
  flex-direction: column;
  gap: var(--spacing-05);
`;
const FieldConfigEmptyMessage = styled.div`
  ${Caption01};
  color: var(--gray-70);
`;
const Wrapper = styled.div`
  height: 100%;
`;
// TODO need to find alternative for height calculation
const FormWrapper = styled.div`
  height: calc(100% - ${WrapperHeight}px);
`;
const DoneButtonWrapper = styled.div`
  margin: var(--layout-01);
`;
const DoneButton = styled(Button)`
  width: 100%;
  align-items: center;
  justify-content: center;
`;

export const FieldPropertiesConfiguration: FC<{
  formTemplate: FormTemplate;
  selectedFormItem: number | FormQuestion | null;
  setSelectedFormItem: Dispatch<SetStateAction<null | FormQuestion | number>>;
  setCreateBranchingDetails: Dispatch<
    SetStateAction<null | CreateBranchingDetailsProps>
  >;
}> = ({
  formTemplate,
  selectedFormItem,
  setCreateBranchingDetails,
  setSelectedFormItem,
}) => {
  const formHeaderSelected =
    Number.isInteger(selectedFormItem) && selectedFormItem === FormHeaderID;
  const DoneButtonText = useTranslation('done');

  return (
    <Wrapper>
      <FormWrapper>
        {formHeaderSelected ? (
          <FormHeaderConfiguration formTemplate={formTemplate} />
        ) : selectedFormItem ? (
          [
            FormQuestionType.CheckBoxGrid,
            FormQuestionType.MultipleChoiceGrid,
          ].includes((selectedFormItem as FormQuestion).formQuestionType) ? (
            <MatrixFormField
              selectedField={selectedFormItem as FormQuestion}
              templateId={formTemplate.templateId}
            />
          ) : (
            <FormFieldConfiguration
              templateId={formTemplate.templateId}
              selectedField={selectedFormItem as FormQuestion}
              setCreateBranchingDetails={setCreateBranchingDetails}
            />
          )
        ) : (
          <FieldConfigurationEmpty>
            <FormFieldPropertiesEmptyImage />
            <FieldConfigEmptyMessage>
              <FormattedMessage id="form_templates.field_configuration.empty" />
            </FieldConfigEmptyMessage>
          </FieldConfigurationEmpty>
        )}
      </FormWrapper>
      {(formHeaderSelected || selectedFormItem) && (
        <DoneButtonWrapper>
          <DoneButton
            type="tertiary"
            onClick={() => setSelectedFormItem(null)}
            data-cy="btn-done.form.configuration"
          >
            {DoneButtonText}
          </DoneButton>
        </DoneButtonWrapper>
      )}
    </Wrapper>
  );
};
